/** MODALMOBILE: TODO */
import React, { useContext } from 'react'

import ModalFullscreen, { Props } from './ModalFullscreen'
import ModalLogin from './ModalLogin'
import P from '../typography/P'
import { ASpan as A } from '../typography/A'
import { ModalsContext } from './Modals'

const ModalForgotPasswordSuccess: React.FC<Props> = (props) => {
  const modalsCtx = useContext(ModalsContext)
  return (
    <ModalFullscreen {...props}>
      <P>
        You will receive an email with instructions about how to reset your
        password shortly.
      </P>
      <A onClick={() => modalsCtx!.show(<ModalLogin />)}>Back to Log In</A>
    </ModalFullscreen>
  )
}

export default ModalForgotPasswordSuccess
